import "bootstrap";
import "angular";
import "angular-animate";
import "angular-cookies";
import "angular-resource";
import "angular-ui-bootstrap";
import "angular-sanitize";
import "angular-touch";
import "angular-messages";
import "angular-ui-router";
import "angular-translate";
import "angular-translate-loader-url";
import "inputmask";
import "../../../client/libs/vendor/angular-mask/dist/ngMask.min.js";
import "cleave.js/src/Cleave.angular.js";

import uiUtils from "../../../client/libs/vendor/angular-ui-utils/ui-utils.js";
import deepLink from "./deepLink/DeepLinkModule";
import authentication from "./authentication/AuthenticationModule";
import mfa from "./mfa/MFAModule";
import oauth from "./oauth/OAUTHModule";
import idProof from "./idProof/IDProofModule";
import registration from "./registration/RegistrationModule";
import npdi from "./npdi/NpdiModule";
import accountSelection from "./accountSelection/AccountSelectionModule";
import accountSetup from "./accountSetup/AccountSetupModule";
import accountRecovery from "./accountRecovery/AccountRecoveryModule";
import profile from "./profile/ProfileModule";
import eConsent from "./eConsent/EConsentModule";
import IndIdSelection from "./indIdSelection/IndIdSelectionModule";
import OneIdModule from "./oneid/OneIdModule";
import iraConsent from "./iraConsent/IraConsentModule";
import BrowserNotificationModule from "./browserNotification/BrowserNotificationModule";
import reEnrollModule from "./reenroll/ReEnrollModule";
import InvestmentInformationModule from "./investmentInformation/InvestmentInformationModule";

import PersonalMessagingModule from "core-ui/client/src/app/PersonalMessagingModule";
import LayoutModule from "core-ui/client/src/app/LayoutModule";
import FullHeight from "core-ui/client/src/app/FullHeight";
import PageTitle from "core-ui/client/src/app/PageTitle";
import ScreenSize from "core-ui/client/src/app/ScreenSize";
import AccessibleTabs from "core-ui/client/src/app/AccessibleTabs";
import errorModule from "core-ui/client/src/app/ErrorModule";
import LoggerModule from "core-ui/client/src/app/LoggerModule";
import ContactModalModule from "core-ui/client/src/app/ContactModalModule";
import TranslateServiceModule from "core-ui/client/src/app/TranslateServiceModule";
import LoadingButton from "core-ui/client/src/app/LoadingButtonDirective";
import EDeliveryModule from "core-ui/client/src/app/EDeliveryModule";
import httpExceptionInterceptorProvider from "core-ui/client/src/app/HttpExceptionInterceptorProvider";
import DynamicArticleRoutingModule from "core-ui/client/src/app/DynamicArticleRoutingModule";
import DynamicElectionRoutingModule from "core-ui/client/src/app/DynamicElectionRoutingModule";
import PrintDirective from "core-ui/client/src/app/PrintDirective";
import GroupModule from "core-ui/client/src/app/GroupModule";
import PaeModule from "core-ui/client/src/app/PaeModule";
import CoreTemplates from "core-ui/client/src/app/CoreTemplates";
import validationDirectives from "./core/ValidationDirectives";

import AdminModule from "admin-ui";
import BeneficiaryModule from "beneficiary-ui/client/src/app/module/beneficiary/BeneficiaryModule";

import routeStates from "./Route";
import { getEnvironmentDisplayName } from "core-ui/client/react/core/utils/getEnvironmentDisplayName";
import beneficiaryRouteStates from "./routes/BeneficiaryRouteStates";
import EDeliveryFactory from "core-ui/client/src/app/EDeliveryFactory";
import httpProvider from "./httpProviderConfig";
import DefaultCustomizationRetrService from "./core/DefaultCustomizationRetrService";
import PreLoginAccuRetrievalService from "./authentication/PreLoginAccuRetrievalService";
import redirectService from "./core/RedirectService";
import LoginUIMasterController from "./core/LoginUIMasterController";
import pscPathRetrievalFactory from "./core/PSCPathRetrievalFactory";
import EventBusModule from "core-ui/client/src/app/EventBusModule";
import focusDirectives from "./core/FocusDirectives";
import AlertMessagesDirective from "core-ui/client/src/app/AlertMessagesDirective";
import AriaLiveOrderDirective from "core-ui/client/src/app/AriaLiveOrderDirective";
import FevaDisclosureDirective from "core-ui/client/src/app/FevaDisclosureDirective";

//############################################################################
//REACT - BEGIN
//############################################################################

import { react2angular } from "react18-react2angular";
//Componets
import coreuiReactComponents from "core-ui/dist/core-ui-react-components";
const {
    HeaderViewProviderComponent,
    FooterViewProviderComponent,
    HeaderPlanMessaging,
    HeaderNoLogin
} = coreuiReactComponents;
import NoCodeModalComponent from "./react/components/idProof/otp/NoCodeModalComponent";
import IdentityVerificationComponent from "./react/components/idProof/otp/IdentityVerificationComponent";
import VerificationCodeEntryComponent from "./react/components/idProof/otp/VerificationCodeEntryComponent";
//My profile
import WorkEmailAddressComponent from "./react/components/profile/WorkEmailAddressComponent";
import LinkablePlansComponent from "./react/components/profile/LinkablePlansComponent";
import PersonalContactInfoComponent from "./react/components/profile/PersonalContactInfoComponent";
import HomeMailingAddressComponent from "./react/components/profile/HomeMailingAddressComponent";
import UsernamePasswordComponent from "./react/components/profile/UsernamePasswordComponent";
import ChangeUsernameComponent from "./react/components/profile/modals/ChangeUsernameComponent";
import ChangePasswordComponent from "./react/components/profile/modals/ChangePasswordComponent";
import EConsentComponent from "./react/components/profile/EConsentComponent";
import ChangeCommunicationPreferenceComponent from "./react/components/profile/modals/ChangeCommunicationPreferenceComponent";
import ProfileBreadcrumbComponent from "./react/components/profile/ProfileBreadcrumbComponent";
import BeneficiariesEditComponent from "./react/components/profile/BeneficiariesEditComponent";
import ChangeHomeAddressComponent from "./react/components/profile/modals/ChangeHomeAddressComponent";
import ChangePersonalContactComponent from "./react/components/profile/modals/ChangePersonalContactComponent";
import AuthorizedDevicesComponent from "./react/components/profile/AuthorizedDevicesComponent";
//Ira Consent
import IraConsentComponent from "./react/components/iraConsent/IraConsentComponent";
import AlternateSiteDialogDirective from "./alternateSiteNotification/AlternateSiteDialogDirective";
// Ira Pre-Account Openning
import IraPreAccountOpenning from "./react/components/registration/iraPreAccountOpenning";
import Registration from "./react/components/registration/Registration";
// Premier IRA new Account opening
import AccountOpenDetailsForm from "./react/components/accountOpen/AccountOpenDetailsForm";
import AccountOpenPersonalDetailsForm from "./react/components/accountOpen/AccountOpenPersonalDetailsForm";

// eslint-disable-next-line no-undef
var application = angular.module("application", [
    /*
     * 3rd Party resources
     */
    "cleave.js",
    "ngAnimate",
    "ngCookies",
    "ngMask",
    "ngMessages",
    "ngResource",
    "ngSanitize",
    "ngTouch",
    "pascalprecht.translate",
    "ui.bootstrap",
    "ui.router",
    /*
     * Features
     */
    AccessibleTabs.name,
    BrowserNotificationModule.name,
    ContactModalModule.name,
    DynamicArticleRoutingModule.name,
    DynamicElectionRoutingModule.name,
    EDeliveryModule.name,
    EventBusModule.name,
    FullHeight.name,
    GroupModule.name,
    IndIdSelection.name,
    InvestmentInformationModule.name,
    LayoutModule.name,
    LoadingButton.name,
    LoggerModule.name,
    OneIdModule.name,
    PaeModule.name,
    PageTitle.name,
    PersonalMessagingModule.name,
    ScreenSize.name,
    TranslateServiceModule.name,

    accountRecovery.name,
    accountSelection.name,
    accountSetup.name,
    authentication.name,
    deepLink.name,
    eConsent.name,
    errorModule.name,
    httpExceptionInterceptorProvider.name,
    idProof.name,
    iraConsent.name,
    mfa.name,
    npdi.name,
    oauth.name,
    profile.name,
    reEnrollModule.name,
    registration.name,
    uiUtils.name,
    validationDirectives.name,

    BeneficiaryModule.name,

    CoreTemplates.name,
    AdminModule.name
]);

application.config(routeStates);
application.config(beneficiaryRouteStates);
application.config(httpProvider);
application.config([
    "$sceDelegateProvider",
    function ($sceDelegateProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            "self",
            "http://localhost:*/**",
            "https://*.retirementpartner.com/**",
            "http://*.retirementpartner.com/**",
            "http://*.empower-retirement.com/**",
            "https://*.empower-retirement.com/**"
        ]);
    }
]);
application.config([
    "$compileProvider",
    function ($compileProvider) {
        var isProd = globalThis.env === "prod" ? true : false;
        $compileProvider.debugInfoEnabled(!isProd);
    }
]);
application.factory("DefaultCustomizationRetrService", DefaultCustomizationRetrService);
application.factory("PreLoginAccuRetrievalService", PreLoginAccuRetrievalService);
application.factory("redirectService", redirectService);
application.factory("pscPathRetrievalFactory", pscPathRetrievalFactory);
application.factory("EDeliveryFactory", EDeliveryFactory);
application.directive("focusDirectives", focusDirectives);
application.directive("printDirective", PrintDirective);
application.directive("srOrder", AriaLiveOrderDirective);
application.directive("alertMessage", AlertMessagesDirective);
application.directive("pwFevaDisclosure", FevaDisclosureDirective);
application.directive("alternateSiteDialog", AlternateSiteDialogDirective);
application.directive("typeaheadShowOnFocus", function () {
    return {
        require: "ngModel",
        link: function ($scope, element, attrs, ngModel) {
            element.bind("focus", function () {
                var viewValue = ngModel.$viewValue;

                //restore to null value so that the typeahead can detect a change
                if (viewValue === "") {
                    ngModel.$setViewValue(null);
                }

                //set the actual value in case there was already a value in the input
                ngModel.$setViewValue(viewValue || "");
            });
            element.bind("click", function () {
                var viewValue = ngModel.$viewValue;

                //restore to null value so that the typeahead can detect a change
                if (viewValue === "") {
                    ngModel.$setViewValue(null);
                }

                //set the actual value in case there was already a value in the input
                ngModel.$setViewValue(viewValue || "");
            });
        }
    };
});

//############################################################################
//REACT (Directives)- BEGIN
//############################################################################

/* Header & Footer */
application.component("headerProvider", react2angular(HeaderViewProviderComponent, ["options"]));
application.component("footerProvider", react2angular(FooterViewProviderComponent, ["options"]));
application.component("headerNoLogin", react2angular(HeaderNoLogin, ["accuCustomization", "urls"]));
application.component(
    "headerPlanMessaging",
    react2angular(HeaderPlanMessaging, [
        "eventBus",
        "navMenu",
        "onViewAllPrevent",
        "prevent",
        "slides",
        "translations",
        "watchDepth"
    ])
);
/* My profile */
application.component(
    "pwrOtpNocodeModalComponent",
    react2angular(NoCodeModalComponent, ["options"])
);
application.component(
    "pwrOtpIdentityVerificationComponent",
    react2angular(IdentityVerificationComponent, ["options", "isOtsUser"])
);
application.component(
    "pwrOtpIdentityVerificationCodeEntryComponent",
    react2angular(VerificationCodeEntryComponent, ["options", "noCodeFunction", "isOtsUser"])
);
application.component(
    "pwrWorkEmailAddressComponent",
    react2angular(WorkEmailAddressComponent, ["profileInfo"])
);
application.component(
    "pwrLinkablePlansComponent",
    react2angular(LinkablePlansComponent, ["profileInfo", "openLinkablePlansPage"])
);
application.component(
    "pwrPersonalContactInfoComponent",
    react2angular(PersonalContactInfoComponent, ["profileInfo", "onClickFunction"])
);
application.component(
    "pwrHomeMailingAddressComponent",
    react2angular(HomeMailingAddressComponent, [
        "country",
        "zipcode",
        "city",
        "state",
        "stline1",
        "stline2",
        "isAddrUpdateAllowed",
        "pinAuthCode",
        "openHomeAddressModal"
    ])
);
application.component(
    "pwrUsernamePasswordComponent",
    react2angular(UsernamePasswordComponent, [
        "isUserNameUpdateAllowed",
        "pinAuthCode",
        "userName",
        "openUsernameModal",
        "openPasswordModal"
    ])
);
application.component(
    "pwrChangeUsernameComponent",
    react2angular(ChangeUsernameComponent, ["cancel", "updateUserName", "componentValue"])
);
application.component(
    "pwrChangePasswordComponent",
    react2angular(ChangePasswordComponent, [
        "cancel",
        "updatePassWord",
        "saveStatus",
        "saveStatusParams",
        "error"
    ])
);
application.component(
    "pwrEConsentComponent",
    react2angular(EConsentComponent, [
        "allowedToOverwrite",
        "displayChangeCommPrefsButton",
        "openModalTemplateCommunicationPreferences",
        "econsentemailAddress",
        "eConsentDetails"
    ])
);
application.component(
    "pwrChangeCommunicationPreferenceComponent",
    react2angular(ChangeCommunicationPreferenceComponent, [
        "primaryPlanT",
        "eConsentDetails",
        "saveStatus",
        "saveStatusParams",
        "updatePPTConsent",
        "updateEConsentDetail",
        "isStandalonePage",
        "email",
        "eConsent",
        "isModalWindow",
        "mustHaveEmail"
    ])
);
application.component(
    "pwrProfileBreadcrumbComponent",
    react2angular(ProfileBreadcrumbComponent, ["url"])
);
application.component(
    "pwrBeneficiariesEditComponent",
    react2angular(BeneficiariesEditComponent, ["plans", "pinAuthCode", "getBeneficiaryName"])
);
application.component(
    "pwrChangeHomeAddressComponent",
    react2angular(ChangeHomeAddressComponent, [
        "cancel",
        "updateHomeAddress",
        "saveStatus",
        "saveStatusParams",
        "stline1",
        "stline2",
        "city",
        "zipcode",
        "stateOptions",
        "countryOptions",
        "selectedCountryValue",
        "selectedStateValue"
    ])
);
application.component(
    "pwrChangePersonalContactComponent",
    react2angular(ChangePersonalContactComponent, [
        "cancel",
        "updatePersonalContact",
        "saveStatus",
        "saveStatusParams"
    ])
);
application.component(
    "pwrIraConsentComponent",
    react2angular(IraConsentComponent, ["groupId", "individualId", "goToNextLocation"])
);
application.component("pwrIraPreAccountOpenning", react2angular(IraPreAccountOpenning, []));
application.component("pwrReg", react2angular(Registration, []));
application.component(
    "pwrOtsAccountDetailsForm",
    react2angular(AccountOpenDetailsForm, [
        "handleDetailsFormSubmit",
        "formData",
        "stateCodes",
        "hasReferrerParam"
    ])
);
application.component(
    "pwrOtsAccountPersonalDetailsForm",
    react2angular(AccountOpenPersonalDetailsForm, [
        "handlePersonalDetailsFormSubmit",
        "formData",
        "isRegistered"
    ])
);
application.component("pwrAuthorizedDevices", react2angular(AuthorizedDevicesComponent, []));
application.controller("LoginUIMasterController", LoginUIMasterController);

//############################################################################
//REACT (Directives)- END
//############################################################################
export default application;

// Bootstrap the application once we are sure the ACCU has been resolved
angular.element(document.querySelector("html")).ready(function () {
    const appName = "application";

    if (window.accuResolved === true) {
        angular.bootstrap(document, [appName]);
    } else if (window.accuWatch) {
        // Wait until accu is resolved
        window.accuWatch.watch(() => {
            angular.bootstrap(document, [appName]);
        });
    }
});
